// единственная правка — конструктор принимает полный URL,
// а reconnect() пригодится при автоматической смене JWT

// readyState по спецификации WebSocket: 0 — CONNECTING, 1 — OPEN. Берём
// литералом, а не с глобального WebSocket, чтобы не зависеть от полноты стаба.
const CONNECTING = 0;

export class ChatSocket {
  private ws: WebSocket | null = null;
  private url: string;
  private listeners = new Map<'message' | 'open' | 'close', Function>();

  constructor(url: string, onMsg?: Function) {
    this.url = url;
    if (onMsg) this.on('message', onMsg);
  }

  connect() {
    if (this.ws) return;
    const ws = new WebSocket(this.url);
    this.ws = ws;
    // Слушатели общие на весь экземпляр, а обработчики остаются висеть на
    // брошенном сокете (disconnect/reconnect). Без проверки «событие от
    // актуального сокета» его поздние open/close выглядят как события живого
    // коннекта: singleton поверх ChatSocket ловит чужой close и плодит
    // дубль-коннекты.
    const isCurrent = () => this.ws === ws;
    ws.addEventListener('open',   () => { if (isCurrent()) this.listeners.get('open')?.(); });
    ws.addEventListener('close',  () => { if (isCurrent()) this.listeners.get('close')?.(); });
    ws.addEventListener('message', e => {
      if (!isCurrent()) return;
      if (!e.data || e.data === 'ping') return;
      try { this.listeners.get('message')?.(JSON.parse(e.data)); }
      catch { console.warn('[WS] bad json payload', e.data); }
    });
  }

  reconnect() { this.disconnect(); this.connect(); }
  on(type: 'message' | 'open' | 'close', cb: Function) { this.listeners.set(type, cb); }

  disconnect() {
    const ws = this.ws;
    this.ws = null;
    if (!ws) return;
    if (ws.readyState === CONNECTING) {
      // close() посреди хендшейка браузер логирует красным «WebSocket is closed
      // before the connection is established». Подписчик может исчезнуть раньше,
      // чем добежит upgrade (транзитная шапка на загрузке админки, open-deadline,
      // reconnect по jwt-refreshed), поэтому ждём исхода: открылся — закрываем,
      // не открылся — коннект умрёт сам.
      ws.addEventListener('open', () => ws.close(), { once: true });
      return;
    }
    ws.close();
  }
  send(payload: unknown) {
    if (this.ws?.readyState === WebSocket.OPEN)
      this.ws.send(JSON.stringify(payload));
  }
}







// type Listener = (payload: any) => void

// export class ChatSocket {
//   private ws: WebSocket | null = null
//   private readonly url: string
//   private listener: Listener

//   constructor(url: string, listener: Listener) {
//     this.url = url
//     this.listener = listener
//   }

//   connect() {
//     if (this.ws) return
//     this.ws = new WebSocket(this.url)
//     this.ws.addEventListener('message', e => {
//       if (!e.data || e.data === 'ping') return
//       try { this.listener(JSON.parse(e.data)) }
//       catch { console.warn('[WS] bad JSON') }
//     })
//   }

//   disconnect() { this.ws?.close(); this.ws = null }
// }




// type Msg = Record<string, unknown>;

// export class ChatSocket {
//     private ws: WebSocket | null = null;
//     private roomId: string;
//     private listeners = new Map<'message' | 'open' | 'close', Function>();

//     constructor(roomId: string) {
//         this.roomId = roomId;
//     }

//     connect() {
//         if (this.ws) return;
//         const url = `wss://logora.ru/ws/chats/${this.roomId}/`;
//         this.ws = new WebSocket(url);

//         this.ws.addEventListener('open', () => this.listeners.get('open')?.());
//         this.ws.addEventListener('close', () => this.listeners.get('close')?.());
//         // this.ws.addEventListener('message', e => {
//         //     try { this.listeners.get('message')?.(JSON.parse(e.data)); }
//         //     catch { console.warn('[WS] bad json'); }
//         // });
//         this.ws.addEventListener('message', e => {
//             // пустой кадр / ping – сразу мимо
//             if (!e.data || e.data === 'ping') return

//             let payload: Msg
//             try {
//                 payload = JSON.parse(e.data)
//             } catch {
//                 console.warn('[WS] non‑JSON payload:', e.data)      // теперь видим «хвост»
//                 return
//             }
//             this.listeners.get('message')?.(payload)
//         })
//     }

//     on(type: 'message' | 'open' | 'close', cb: Function) {
//         this.listeners.set(type, cb);
//     }
//     disconnect() { this.ws?.close(); this.ws = null; }
//     send(data: unknown) {
//         this.ws?.readyState === WebSocket.OPEN &&
//             this.ws.send(JSON.stringify(data));
//     }
// }
